import React from "react";
import vector from "../assets/images/Vector.svg";
import "./header.component.scss";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import notification from "../assets/images/notification.svg";
import profileimage from "../assets/images/profileimage.svg";
import Vector222 from "../assets/images/Vector222.svg";
import Button from "@mui/material/Button";
import { useState, useEffect } from "react";
import { SessionService } from "../Services/session.service";
import { AuthenticationService } from "../Services/authentication.service";
import { useLoading } from "../Shared/services/loading-context";
import { ProjectService } from "../Services/project.service";
import ModalComponent from "./modal.component";
import { DefaultButton } from "./default-button.component";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import { PrimaryButton } from "./primary-button.component";
import { ProjectRequestService } from "../Services/project-request.service";
import { UserRoles } from "../Shared/consts/user-roles.enum";

export const Header: React.FunctionComponent<any> = (props) => {
  const [toggle, setToggle] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  // const [toggleE, setToggleE] = useState(false);
  // const [anchorE, setAnchorE] = React.useState<null | HTMLElement>(null);
  const [projectDetails, setProject] = useState<any>();
  const [projects, setProjects] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isRequestModalOpen, setIsRequestModalOpen] = useState<boolean>(false);
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { loading, setLoading } = useLoading();

  const modalStyle = {
    border: "none",
    width: "430px",
    height: "430px",
    background: "#FFFFFF",
    boxShadow: "0px 0px 10px 3px rgb(2 4 4 / 7%)",
    borderRadius: "15px",
    padding: 0,
    overflow: "auto",
  };

  useEffect(() => {
    const user = SessionService.user();
    console.log(user)
    setProject(user);
    // getUserProjects();
  }, [])

  const getUserProjects = async () => {
    setLoading(true);
    const response = await ProjectService.userprojects();
    setLoading(false);
    if (response.success) {
      const projectData = response.data.map((x: any) => x.project);
      setProjects(projectData);
    } else {
      enqueueSnackbar(response.message ?? "Internal server error", { variant: "error" });
    }
  }

  const handleClose = () => {
    setAnchorEl(null);
    setToggle(false);
  };

  const onModalClose = async (loadRecords?: boolean) => {
    setIsModalOpen(false);
  };

  const openProjectSelection = () => {
    getUserProjects();
    setIsModalOpen(true);
    handleClose();
  }
  const onSelectProject = async (project: any) => {
    setLoading(true);
    const response = await ProjectService.changeproject(project.id);
    setLoading(false);
    if (response.success) {
      const { token, user } = response.data;
      SessionService.setUser(user);
      SessionService.setToken(token);
      window.location.reload();
    }
  }
  const addProject = async () => {
    setLoading(true);
    const response = await ProjectRequestService.create();
    setLoading(false);
    if (response.success) {
      const requestId = response.data;
      // enqueueSnackbar("Your request has been completed shortly we will contact you", { variant: "success" });
      const user = SessionService.user();
      if (user.role == UserRoles.BUILDER_SUPER_ADMIN) {
        navigate("/projectdetails?requestId=" + requestId);
      } else {
        setIsRequestModalOpen(true);
        onModalClose();
      }
      // navigate("/projectdetails/new");
    } else {
      enqueueSnackbar(response.message ?? "Internal server error", { variant: "error" });
    }
  }

  const logout = () => {
    AuthenticationService.logout();
    window.location.href = "/";
  };

  const handleDrawerToggle = () => {
    props.handleDrawerToggle();
  };

  const profileClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setToggle(true);
  };

  return (
    <div>
      <Box className="header" sx={{ flexGrow: 5 }}>
        <Toolbar style={{ color: "black" }}>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
            onClick={handleDrawerToggle}
          >
            <MenuIcon />
          </IconButton>

          <Button onClick={openProjectSelection} className="project-menu" style={{ marginRight: "40px" }}>
            {projectDetails?.projectName}
            {/* <div style={{ marginLeft: "15px" }}>
              <KeyboardArrowDownIcon />
            </div> */}
          </Button>

          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1 }}
          ></Typography>
          <button className="notificationButton">
            <img className="img" src={notification} />
          </button>
          <Typography className="accountName">Hi, {projectDetails?.name}</Typography>
          <div>
            <Button onClick={profileClick} style={{ marginRight: "40px" }}>
              <img src={profileimage} />
              <div style={{ marginLeft: "15px" }}>
                <img src={Vector222} />
              </div>
            </Button>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={toggle}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              <MenuItem onClick={handleClose}>Profile</MenuItem>
              <MenuItem onClick={handleClose}>My account</MenuItem>
              <MenuItem onClick={logout}>Logout</MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </Box>

      <ModalComponent
        customHeader={true}
        style={{ ...modalStyle, padding: "1rem", height: "auto", minHeight: "auto" }}
        isModalOpen={isRequestModalOpen}
        hideModal={() => { setIsRequestModalOpen(false) }}
      >
        <span className="request-label"> Your request has been received, we will contact you shortly. </span>
        <div className="request-ok-btn">
          <PrimaryButton style={{ width: "108px", marginTop: "15px" }} onClick={() => setIsRequestModalOpen(false)}>
            Ok
          </PrimaryButton>
        </div>
      </ModalComponent>
      <ModalComponent
        customHeader={true}
        style={modalStyle}
        isModalOpen={isModalOpen}
        hideModal={onModalClose}
      >
        <div className="selection-modal">
          <span className="selectCustomerText">Select Employee</span>
          <DefaultButton onClick={addProject}>Add New Property </DefaultButton>
        </div>
        {projects.map((currElem: any) => (
  <Box
    key={currElem._id || currElem.id || currElem.name} // ✅ Unique key added here
    onClick={() => onSelectProject(currElem)}
    className="d-flex justify-content-between"
    sx={{
      margin: "auto 20px",
      marginTop: "15px",
      padding: "16px 20px",
      border: "2px solid #E8E8E8",
      position: "relative",
      cursor: "pointer",
      borderRadius: "10px",
    }}
  >
    <span className="modalListName">{currElem.name}</span>
  </Box>
))}

      </ModalComponent>
    </div>
  );
};
